module.exports = __webpack_public_path__ + "img/bz2.a80fba9d.png";